import './main.css'
import Vue from 'vue'
import store from './store'
import './registerServiceWorker'
import Map from './components/Map.vue'
import Search from './components/Search.vue'
import Header from './components/Header.vue'
import Autocomplete from 'vue2-autocomplete-js'

Vue.component('Autocomplete', Autocomplete)
Vue.config.productionTip = false

if(!(window.fetch && window.Promise)){
  var js = document.createElement('script')
  js.src = 'https://polyfill.io/v3/polyfill.min.js?features=Promise%2Cfetch'
  js.crossorigin = 'anonymous'
  document.head.appendChild(js)
}

new Vue({
  store,
  render: h => h(Map)
}).$mount('map-container')

new Vue({
  store,
  render: h => h(Search)
}).$mount("search-container")

new Vue({
  store,
  render: h => h(Header)
}).$mount('head-container')